import type { UserCompany } from '@/hooks/useUsersData';

/**
 * Mock user companies for demo mode - list of available companies with some pre-linked
 */
export const mockUserCompanies: UserCompany[] = [
  { id: 1, name: 'Acme Corporation', code: 'ACME', isLinked: true },
  { id: 2, name: 'TechStart Inc.', code: 'TECH', isLinked: false },
  { id: 3, name: 'Global Solutions Ltd.', code: 'GLBL', isLinked: true },
  { id: 4, name: 'Innovation Partners', code: 'INNOV', isLinked: false },
  { id: 5, name: 'Enterprise Systems', code: 'ENTSYS', isLinked: false },
];
